import {
  AppBar,
  Avatar,
  Box,
  CssBaseline,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoreTypographyBody1 from "../dataDisplay/CoreTypographyBody1";
import MenuIcon from "@mui/icons-material/Menu";
import { AccountCircle } from "@mui/icons-material";
import SideBar from "./SideBar";
import { API_METHOD_POST } from "../../config/constants";
import {
  AUTH_LOADING,
  LOGOUT_ERROR,
  LOGOUT_SUCCESS,
} from "../../store/types/authTypes";
import { api_request } from "../../store/actions/commonAction";
import CoreH4 from "../dataDisplay/CoreH4";
import { theme } from "../../config/theme";
import SettingsManagement from "../../modules/invoice/SettingsManagement";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";
import CoreTypographySubtitle2 from "../dataDisplay/CoreTypographySubtitle2";
import { Link } from "react-router-dom";

export default function CoreAppbar({ open, onOpen }) {
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [openConfigModal, setConfigModal] = React.useState(false);
  const dispatch = useDispatch();

  const chechUserExistData = useSelector(
    (state) => state?.auth?.chechUserExistData,
  );
  const user = useSelector((state) => state?.auth?.user);
  const profile = useSelector((state) => state?.profile?.basic);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleLogout = () => {
    handleClose();
    dispatch(
      api_request(
        API_METHOD_POST,
        "/logout",
        {},
        {},
        AUTH_LOADING,
        LOGOUT_SUCCESS,
        LOGOUT_ERROR,
        true,
        false,
      ),
    );
  };

  const handleSettings = () => {
    setConfigModal(true);
    handleClose();
  };

  console.log(user);
  return (
    <>
      <CssBaseline />
      <SettingsManagement
        open={openConfigModal}
        setModal={() => {
          setConfigModal(false);
        }}
      />
      <AppBar position="fixed" sx={{ zIndex: 1500 }}>
        <Toolbar>
          <Box style={{ width: "80%", display: "flex", alignItems: "center" }}>
            <Box>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={onOpen}
              >
                <Icon style={{ color: theme.palette.primary.main }}>menu</Icon>
              </IconButton>
            </Box>
            <Link to={"/dashboard"}>
              <img
                style={{ alignSelf: "center" }}
                height="50px"
                // width="10px"
                src="/docxplor-logo-full.webp"
                alt="Logo of docxplor"
              />
              {/* <CoreH4 style={{ fontWeight: 700 }}>DocXplor</CoreH4> */}
            </Link>
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              width: "20%",
            }}
          >
            <IconButton
              // size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="secondary"
            >
              {profile?.photoUrl ? (
                <Avatar src={profile?.photoUrl} />
              ) : (
                <AccountCircle fontSize="large" />
              )}
            </IconButton>
          </Box>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {/* <MenuItem onClick={handleClose}>Profile</MenuItem>  */}
            {/* <MenuItem onClick={handleSettings}>
              <Icon style={{ marginRight: 16 }}>settings</Icon>
              Settings
            </MenuItem> */}
            <Link to="/usage" style={{ textDecoration: "none" }}>
              <MenuItem>
                <Icon style={{ marginRight: 16 }}>bar_chart</Icon>
                Usage
              </MenuItem>
            </Link>
            <MenuItem onClick={handleLogout}>
              <Icon style={{ marginRight: 16 }}>logout</Icon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <SideBar open={open} />
    </>
  );
}
